import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import {
    Button, Col,
    Row, Form,
    FormGroup, Label
} from 'reactstrap';
import { connect } from 'react-redux'
import Dropdown from '../Dropdown/index'
import * as createCaseActions from '../../../../Analyst/Cases/Create/actions'
import { Preloading } from '../../../../components/UI/Preloader/action';
import { setPageView, goolgeAnalyticsEvents } from '../../../../components/GoogleAnalytics/index';
import { DOMESTIC, INTERNATIONAL, INDIA } from '../../constant';
import * as StringConst from '../../constant';
import { formValueSelector } from 'redux-form';
import { toast } from "react-toastify";
import * as portfolioConstant from '../../../my-portfolio/constants'

const selector = formValueSelector('KycBuyForm');
class KycBuyForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            buyModalTypeFlag: false,
            disable: true,
            disablecounterParty: true,
            showModal: false,
            productsData: [],
            businessSegmentData: [],
            validation: null,
            productFetch: true,
            selectedProduct: undefined,
            selectedCounterpartyType: undefined,
            defaultZone: undefined,
            selectedBusinessSegment: undefined,
            kycRequestType: StringConst.EKYC

        };
        this.data = [];
        this.newProp = "";
        this.newProduct = "";
        this.status = "";
        this.error = "";
    }

    componentDidMount() {
        setPageView('/Corporate/KycBuyForm', document.location.href);
        if (!this.props.zoneForState) {
            this.props.getZoneList();
        }
        if (this.props.buyFormType === 'PORTFOLIO_BUY') {
            this.props.preloading(true);
            this.props.handleResizeZIndex(true);
            this.props.getProducts(this.props.userDetails.corporateId, this.props.selectedvalue, this.props.selectedProductCategory, portfolioConstant.KYC)
        } else if (this.props.buyFormType === 'GLOBAL_SEARCH_RESULT_BUY') {
            this.props.getCounterpartyType();
        }
        this.props.getAllDivisionSubsidiary(this.props.userDetails.corporateId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.buyFormType !== this.props.buyFormType) {
            if (this.props.buyFormType === 'PORTFOLIO_BUY') {
                this.setState({
                    buyModalTypeFlag: true
                });
            } else {
                this.setState({
                    buyModalTypeFlag: false
                });
            }
        };

        const {counterpartyTypeSelected, getProducts } = this.props
        if (this.props.counterpartyType != prevProps.counterpartyType && this.props.counterpartyType && this.props.counterpartyType.length > 0 && this.state.productFetch) {
            this.props.getProducts(this.props.userDetails.corporateId, this.props.counterpartyType[0], this.props.selectedProductCategory, portfolioConstant.KYC);
            this.setState({ productFetch: false, selectedCounterpartyType: this.props.counterpartyType[0] });
        }
        if (this.props.zoneList != prevProps.zoneList && this.props.zoneList && this.props.zoneList.length > 0) {
            this.setState({ defaultZone: this.props.zoneList[0] });
        }
       
        if (counterpartyTypeSelected && counterpartyTypeSelected.values && counterpartyTypeSelected !== prevProps.counterpartyTypeSelected) {
            this.setState({
                disable: false
            })
            if (this.props.buyFormType !== 'PORTFOLIO_BUY') {
                if (counterpartyTypeSelected.values.counterpartytype !== undefined && (prevProps.counterpartyTypeSelected.values === undefined || prevProps.counterpartyTypeSelected.values.counterpartytype === undefined)) {
                    this.props.preloading(true);
                    this.props.handleResizeZIndex(true);
                    getProducts(this.props.userDetails.corporateId,
                        counterpartyTypeSelected.values.counterpartytype, this.props.selectedProductCategory, portfolioConstant.KYC)
                }
                else if (counterpartyTypeSelected.values.counterpartytype && prevProps.counterpartyTypeSelected.values !== undefined && prevProps.counterpartyTypeSelected.values.counterpartytype && counterpartyTypeSelected.values.counterpartytype !== prevProps.counterpartyTypeSelected.values.counterpartytype) {
                    this.props.preloading(true);
                    this.props.handleResizeZIndex(true);
                    getProducts(this.props.userDetails.corporateId,
                        counterpartyTypeSelected.values.counterpartytype, this.props.selectedProductCategory, portfolioConstant.KYC)
                }
            }

        }
        if (this.props.products !== prevProps.products) {
            if (this.props.products.length > 0) {
                this.setState({
                    productsData: this.props.products,
                    disable: false,
                    selectedProduct: this.props.products[0].id
                })
            }
            else {
                this.setState({
                    productsData: this.props.products,
                    disable: false,
                    selectedProduct: null
                })
            }
            this.props.preloading(false);
            this.props.handleResizeZIndex(false);
        }

        if (this.props.allDivisionSubsidiary != prevProps.allDivisionSubsidiary) {
            this.setState({
                businessSegmentData: this.props.allDivisionSubsidiary,
                disable: false,
                selectedBusinessSegment: this.props.allDivisionSubsidiary[0].id
            })
        }

        if (this.props.buyFormType !== prevProps.buyFormType) {
        }
    }
    
    mySubmitHandler = (data) => {
        let tempCoporateId,
            tempRequestedById, caseType, zoneSelectedId;

        if (this.props.selectedCounterParty.corporateId && this.props.selectedCounterParty.corporateUserId) {
            tempCoporateId = this.props.selectedCounterParty.corporateId;
            tempRequestedById = this.props.selectedCounterParty.corporateUserId
        } else {
            tempCoporateId = null;
            tempRequestedById = null;
        }
        if (this.props.selectedCounterParty.country === INDIA) {
            caseType = DOMESTIC
        } else {
            caseType = INTERNATIONAL
        }
        if (this.props.zoneForState) {
            zoneSelectedId = this.props.zoneForState.zoneId
        }
        else {
            zoneSelectedId = data.zone ? data.zone : this.state.defaultZone.id
        }
        
        this.case = {
            "productId": data.product ? data.product : this.state.selectedProduct,
            "corporateId": data.businessSegment ? data.businessSegment : this.state.selectedBusinessSegment,
            "requestedById": tempRequestedById,
            "participantName": this.props.participantName,
            "kycType": this.props.isVkycRequest ? StringConst.VKYC : StringConst.EKYC,
            "participantAadhaarNo": this.props.participantAadhaarNo,
            "participantPanNo": this.props.participantPanNo,
            "bankAccountNumber": this.props.participantCompanyBankAccountNo,
            "bankIfscCode": this.props.participantCompanyBankIfscCode,
            "address": this.props.participantCompanyAddress,
            "participantEmail": this.props.participantEmail,
            "participantPhone": this.props.participantPhone,
            "meetingDate": this.props.meetingDate,
            "meetingTime": this.props.meetingTime,
            "caseType": caseType,
            "requestType":"CLIENT_PORTAL"
        }
        
        if (!this.props.participantPhone && !this.props.participantEmail && this.props.isVkycRequest) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;
                    {"Either Phone or email is mandatory !!"}
                </div>,
            );
            return;
            
        }else if (this.props.selectedCounterParty.counterpartyId) {
            this.case = {
                ...this.case,
                "counterpartyId": this.props.selectedCounterParty.counterpartyId,
            }
            if (this.props.buyFormType === 'PORTFOLIO_BUY') {
                this.case = {
                    ...this.case,
                    "counterpartyType":  this.props.selectedvalue,
                    "zoneId": zoneSelectedId,
                }
            } else {
                this.case = {
                    ...this.case,
                    "counterpartyType": data.counterpartytype ? data.counterpartytype : this.state.selectedCounterpartyType,
                    "zoneId": zoneSelectedId,
                }
            }
            goolgeAnalyticsEvents('Corporate', 'Create Kyc Case For Selected Counterparty From Global Search', 'Create Case', '');
            this.props.createCase(this.case)
        } else {
            let tempDataSelected = [];
            this.props.selectedValueData.forEach((selectedCheckboxData, index, element) => {
                this.props.zoneSelected.forEach((zone, i, zoneData) => {
                    if (zone.name === selectedCheckboxData.zoneName) {
                        tempDataSelected.push({
                            counterpartyId: selectedCheckboxData.counterpartyId,
                            zoneId: zone.id
                        })
                    }

                })
            })
            this.case = {
                ...this.case,
                "caseBulkRequestMetadataList": tempDataSelected,
                "counterpartyType": this.props.selectedvalue
            }
            this.props.createBulkBuy(this.case);
        }
        this.props.preloading(true)
        this.props.toggle()
    }


    handleCancel = () => {
        this.props.toggle()
    }

    render() {

        const { handleSubmit } = this.props;
        if (this.props.selectedCounterParty.country === INDIA) {
            return (

                <Form onChange={this.handleFormChange} onSubmit={handleSubmit((val) => { this.mySubmitHandler(val) })} autoComplete="on">
                    <FormGroup>
                        <Label>Counterparty Type</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="counterpartytype"
                                    label="dropDownSelect"
                                    component={Dropdown}
                                    validate={this.state.validation}
                                    className="form-control"
                                    defaultValue={this.props.selectedvalue}
                                    selectedValue={this.props.selectedvalue}
                                    data={this.props.counterpartyType}
                                    dis={this.state.buyModalTypeFlag}
                                    type={this.props.buyFormType}
                                >
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>

                    <FormGroup>
                        <Label>Product</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="product"
                                    label="dropDownSelect"
                                    component={Dropdown}
                                    className="form-control"
                                    defaultValue={this.state.selectedProduct}
                                    data={this.state.productsData}
                                    dis={this.state.disable}
                                >
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>

                    <FormGroup>
                        <Label>Business Segment</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="businessSegment"
                                    label="dropDownSelect"
                                    component={Dropdown}
                                    className="form-control"
                                    defaultValue={this.state.selectedBusinessSegment}
                                    data={this.state.businessSegmentData}
                                    dis={this.state.disable}
                                >
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>

                    <FormGroup>
                        {this.props.isVkycRequest ? null : <Label>Participant Name &nbsp;<span className="text-danger">*</span></Label>}           
                        <Row>
                            <Col>
                                <Field
                                    name="participantName"
                                    validate={this.props.isKycRequest && required}
                                    className="form-control"
                                    type="text"
                                    component={this.props.isVkycRequest ? renderField : commonRenderField}
                                    label="Participant Name."
                                    placeholder="participant name"

                                />
                            </Col>
                        </Row>
                    </FormGroup>


                    <FormGroup>
                        <Label>Participant Aadhaar No.</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="participantAadhaarNo"
                                    className="form-control"
                                    type="text"
                                    component={commonRenderField}
                                    validate={[isValid]}
                                    label="Participant Aadhaar No."
                                    placeholder="Participant Aadhaar No."
                                />
                            </Col>
                        </Row>
                    </FormGroup>

                    <FormGroup>
                        {this.props.isVkycRequest ? null : <Label>Participant Pan No.</Label>}
                        <Row>
                            <Col>
                                <Field
                                    name="participantPanNo"
                                    className="form-control"
                                    type="text"
                                    component={this.props.isVkycRequest ? renderField : commonRenderField}
                                    validate={this.props.isVkycRequest ? required : undefined}
                                    label="Participant pan no"
                                    placeholder="Participant Pan No."
                                />
                            </Col>
                        </Row>
                    </FormGroup>


                    <FormGroup>
                        <Label>Participant Bank Account No.</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="participantCompanyBankAccountNo"
                                    className="form-control"
                                    type="text"
                                    component={commonRenderField}
                                    validate={[isValid]}
                                    label="participant bank account no"
                                    placeholder="Participant Bank Account No."
                                />
                            </Col>
                        </Row>
                    </FormGroup>


                    <FormGroup>
                        <Label>Participant Bank IFSC Code</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="participantCompanyBankIfscCode"
                                    className="form-control"
                                    type="text"
                                    component={commonRenderField}
                                    validate={[isValid]}
                                    label="participant bank ifsc code"
                                    placeholder="Participant Bank Ifsc Code"
                                />
                            </Col>
                        </Row>
                    </FormGroup>


                    <FormGroup>
                        {this.props.isVkycRequest ? null : <Label>Address</Label>}
                        <Row>
                            <Col>
                                <Field
                                    name="participantCompanyAddress"
                                    className="form-control"
                                    type="text"
                                    component={this.props.isVkycRequest ? renderField : commonRenderField}
                                    validate={[isValid]}
                                    label="Address"
                                    placeholder="Address"
                                />
                            </Col>
                        </Row>
                    </FormGroup>


                    <FormGroup>
                        <Label>Email</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="participantEmail"
                                    className="form-control"
                                    type="text"
                                    component={commonRenderField}
                                    validate={[isValid]}
                                    label="participant email"
                                    placeholder="Participant Email"
                                />
                            </Col>
                        </Row>
                    </FormGroup>


                    <FormGroup>
                     <Label>Participant Phone.</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="participantPhone"
                                    className="form-control"
                                    type="text"
                                    component={commonRenderField}
                                    label="Participant Phone"
                                    placeholder="Participant phone"
                                />
                            </Col>
                        </Row>
                    </FormGroup>

                    {this.props.isVkycRequest?
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Field
                                        name="meetingDate"
                                        className="form-control"
                                        type="date"
                                        label="Meeting Date"
                                        validate={[required]}
                                        readOnlyValue={false}
                                        component={renderField}

                                    />
                                </Col>
                            </Row>
                        </FormGroup> : null
                    }

                    {
                        (this.props.isVkycRequest?
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Field
                                            name="meetingTime"
                                            className="form-control"
                                            type="time"
                                            label="Meeting Time"
                                            validate={[required]}
                                            readOnlyValue={false}
                                            component={renderField}

                                        />
                                    </Col>
                                </Row>
                            </FormGroup> : null)
                    }

                    <Button color="primary" type="submit" id="buySubmit" className="mt-5">Submit</Button>
                    <Button color="danger" type="button" id="buyCancel" className="mt-5 ml-5" onClick={this.handleCancel}>Cancel</Button>
                </Form>
            )
        } else {
            return (

                <Form onChange={this.handleFormChange} onSubmit={handleSubmit((val) => { this.mySubmitHandler(val) })} autoComplete="on">
                    <FormGroup>
                        <Label>Counterparty Type</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="counterpartytype"
                                    label="dropDownSelect"
                                    component={Dropdown}
                                    validate={this.state.validation}
                                    className="form-control"
                                    defaultValue={this.props.selectedvalue}
                                    selectedValue={this.props.selectedvalue}
                                    data={this.props.counterpartyType}
                                    dis={this.state.buyModalTypeFlag}
                                    type={this.props.buyFormType}
                                >
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Label>Product</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="product"
                                    // component="select"
                                    label="dropDownSelect"
                                    component={Dropdown}
                                    // validate={[required]}
                                    className="form-control"
                                    defaultValue={this.state.selectedProduct}
                                    data={this.state.productsData}
                                    dis={this.state.disable}
                                >
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Label>Business Segment</Label>
                        <Row>
                            <Col>
                                <Field
                                    name="businessSegment"
                                    label="dropDownSelect"
                                    component={Dropdown}
                                    className="form-control"
                                    defaultValue={this.state.selectedBusinessSegment}
                                    data={this.state.businessSegmentData}
                                    dis={this.state.disable}
                                >
                                </Field>
                            </Col>
                        </Row>

                    </FormGroup>


                    <Button color="primary" type="submit" id="buySubmit" className="mt-5">Submit</Button>
                    <Button color="danger" type="button" id="buyCancel" className="mt-5 ml-5" onClick={this.handleCancel}>Cancel</Button>
                </Form>
            )
        }

    }
}

const required = value => value ? undefined : 'Required';
const isValid = value => !value || value.match(/^[^<>!$%^?*~`{}=]*$/) ? null : 'Please enter valid Input';

const mapStateToProps = (state, ownProps) => ({
    userDetails: state.loginDetails.userDetails,
    products: state.createCase.products,
    allDivisionSubsidiary: state.createCase.allDivisionSubsidiary,
    zoneList: state.createCase.zoneList,
    counterpartyType: state.createCase.dropdownData,
    counterpartyTypeSelected: state.form.KycBuyForm,
    selectedCounterParty: state.corporate.selectedCounterParty,
    isKycRequest: true,
    participantName: selector(state, 'participantName'),
    kycRequestType: selector(state, 'kycRequestType'),
    participantAadhaarNo: selector(state, 'participantAadhaarNo'),
    participantPanNo: selector(state, 'participantPanNo'),
    participantCompanyBankAccountNo: selector(state, 'participantCompanyBankAccountNo'),
    participantCompanyBankIfscCode: selector(state, 'participantCompanyBankIfscCode'),
    participantCompanyAddress: selector(state, 'participantCompanyAddress'),
    participantEmail: selector(state, 'participantEmail'),
    participantPhone: selector(state, 'participantPhone'),
    meetingDate: selector(state, 'meetingDate'),
    meetingTime: selector(state, 'meetingTime')
})

const mapDispatchToProps = (dispatch) => ({

    getCounterpartyType: () => { dispatch(createCaseActions.getCounterpartyType()) },
    getZoneList: () => { dispatch(createCaseActions.getZone()) },
    getProducts: (corporateId, type, selectedProductCategory) => { dispatch(createCaseActions.getProducts(corporateId, type, selectedProductCategory)) },
    getAllDivisionSubsidiary: (corporateId) => { dispatch(createCaseActions.getAllDivisionSubsidiary(corporateId)) },
    createCase: (data) => {
        data.isKycRequest = true;
        dispatch(createCaseActions.createCase(data))
    },
    createBulkBuy: (data) => { dispatch(createCaseActions.createBulkBuy(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});

const commonRenderField = ({ className, input, label, type, isRequired, meta: { touched, error, warning } }) => (
    <Row className="mb-3 align-items-center">
        <Col>
            <input {...input} placeholder={label} type={type} className={className} />
            {touched &&
                ((error && <span className="text-danger">{error}</span>) ||
                    (warning && <span className="text-warning">{warning}</span>))}
        </Col>
    </Row>
)

const renderField = ({ className, input, label, type, dis, placeholder, onclick, readOnlyValue,
    meta: { touched, error, warning } }) => {

    return (

        <FormGroup>
            <Label>{label}&nbsp;<span className="text-danger">*</span></Label>
            <Row>
                <Col>
                    <input {...input} disabled={dis} onClick={onclick} placeholder={placeholder} type={type} className={className} required readOnly= {false} />
                    {touched && ((error && <span className="error text-danger">{error}</span>) || (warning && <span>{warning}</span>))}
                </Col>
            </Row>
        </FormGroup>

    )
}

export default reduxForm({
    form: 'KycBuyForm'
})(connect(mapStateToProps, mapDispatchToProps)(KycBuyForm))//
